module.exports = __webpack_public_path__ + "img/images-icon.8140b8a5.svg";